import {StyleSheet, Platform} from 'react-native';

export default StyleSheet.create({
  outerContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    shadowColor: '#000000',
    shadowOpacity: .2,
    shadowRadius: 6,
    shadowOffset: {
      width: 1,
      height: 1,
    },
    elevation: 2,
    overflow: 'visible',
  },

  container: {
    width: 300,
    backgroundColor: '#FFFFFF',
    paddingTop: 16,
    paddingBottom: 20,
    borderRadius: 6,
  },

  containerTertiaryButton: {
    paddingBottom: 30,
  },

  titleV2: {
    textAlign: 'center',
    color: '#000000',
    fontSize: 20,
    fontStyle: 'normal',
    fontFamily: 'OpenSans-Bold',
    fontWeight: Platform.select({
      ios: '700',
      android: 'bold',
    }),
    marginHorizontal: 21,
    marginBottom: 18,
  },

  titleV1: {
    textAlign: 'center',
    color: '#121212',
    fontSize: 24,
    fontStyle: 'normal',
    fontFamily: 'HelveticaNeue',
    fontWeight: Platform.select({
      ios: '500',
      android: 'bold',
    }),
    marginHorizontal: 21,
    marginBottom: 18,
  },


  bodyContainer: {
    marginHorizontal: 16,
  },

  textV2: {
    color: '#000000',
    textAlign: 'center',
    fontSize: 16,
    fontStyle: 'normal',
    fontFamily: 'OpenSans-Regular',
    fontWeight: 'normal',
    marginHorizontal: 25,
  },

  textV1: {
    color: '#5A5A5A',
    textAlign: 'center',
    fontSize: 18,
    fontStyle: 'normal',
    fontFamily: 'HelveticaNeue',
    fontWeight: 'normal',
    marginHorizontal: 25,
  },

  buttonV2: {
    borderRadius: 60,
    marginHorizontal: 20,
  },

  buttonV1: {
    backgroundColor: '#121212',
    borderRadius: 60,
    marginHorizontal: 16,
  },

  buttonSecondV2: {
    marginTop: 20,
    marginHorizontal: 16,
    borderRadius: 60,
  },

  buttonSecondV1: {
    marginTop: 8,
    marginHorizontal: 16,
    borderColor: '#121212',
    borderRadius: 60,
    borderWidth: 1,
    backgroundColor: '#FFFFFF',
  },

  buttonTitleV1: {
    color: '#121212',
  },

  imageContainer: {
    marginTop: 16,
    justifyContent: 'center',
    alignItems: 'center',
  },

  image: {
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
  },

  padder: {
    height: 32,
  },

  toggleContainer: {
    marginTop: 24,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },

  toggleTextV2: {
    color: '#000000',
    textAlign: 'center',
    fontSize: 16,
    fontStyle: 'normal',
    fontFamily: 'OpenSans-Regular',
    fontWeight: 'normal',
    alignItems: 'center',
    paddingLeft: 12,
  },

  toggleTextV1: {
    color: '#5A5A5A',
    textAlign: 'center',
    fontSize: 18,
    fontStyle: 'normal',
    fontFamily: 'HelveticaNeue',
    fontWeight: 'normal',
    alignItems: 'center',
    paddingLeft: 12,
  },

  selectedToggle: {
    width: 26,
    height: 26,
    backgroundColor: '#000000',
    alignItems: 'center',
    justifyContent: 'center',
  },

  unselectedToggle: {
    width: 26,
    height: 26,
    borderWidth: 1,
    borderColor: '#000000',
    backgroundColor: '#FFFFFF',
    alignItems: 'center',
    justifyContent: 'center',
  },

  checkMark: {
    width: 12,
    height: 12,
  },
});
